// extracted by mini-css-extract-plugin
export var basePrice = "order-list-item-module--base-price--g43QX";
export var orderCard = "order-list-item-module--order-card--F25on";
export var orderHeader = "order-list-item-module--order-header--nDmlC";
export var price = "order-list-item-module--price--3EA8B";
export var summary = "order-list-item-module--summary--wXNxe";